<template>
  <b-modal
    centered
    id="select-update-dialog"
    modal-class="overflow-hidden"
    static
    scrollable
    @hidden="onHidden"
    v-model="showModalUpdate"
  >
    <template #modal-header="{ close }">
      <h5>Cập nhật công việc</h5>
      <b-button size="sm" variant="light" @click="close()"> x </b-button>
    </template>
    <div class="row">
      <div class="wrapper-selected">
        <b-form-group v-slot="{ ariaDescribedby }">
          <b-form-radio-group v-model="purposesSelected" :aria-describedby="ariaDescribedby">
            <b-form-radio v-for="op in optionsPurpose" :value="op.id" :key="op.id">{{
              op.text
            }}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </div>
    </div>
    <hr />
    <div>
      <div class="form-row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="status">Trạng thái</label>
            <b-form-select v-model="data.selectedStt" size="sm">
              <option v-for="(item, index) in dataStatus" :key="index" :value="item.id">
                {{ item.text }}
              </option>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="status">Kết quả</label>
            <b-form-select v-model="data.selectedResult" size="sm">
              <option v-for="(item, index) in dataResult" :key="index" :value="item.id">
                {{ item.text }}
              </option>
            </b-form-select>
          </div>
        </div>
      </div>
      <!-- <div class="form-group">
          <label>Thời gian xử lý</label>
          <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="dateRangeProcessing"
              :locale-data="localeData"
              :timePicker="true"
            :timePicker24Hour="true"

            >
              <template v-slot:input="picker">
                <label v-if="picker.startDate && picker.endDate" style="min-width: 13.5em" class="text-center font-size-12">
                  {{ picker.startDate | formatDate('HH:mm DD/MM/YYYY')  }} - {{ picker.endDate | formatDate('HH:mm DD/MM/YYYY')  }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian
                </label>
              </template>
            </DateRangePicker>
          </div> -->
      <div class="form-group">
        <label>Thời gian xử lý</label>
        <InputRange v-model="dateRangeProcessing"></InputRange>
      </div>
      <div class="form-group">
        <label>Lý do</label>
        <Select2MultipleControl
          v-if="['MC_INACTIVE', 'MC_DECREASE_TPV'].includes(data.noteUpdateType)"
          :settings="{ closeOnSelect: false }"
          v-model="data.noteUpdateArr"
          :options="data.resonArr"
        >
        </Select2MultipleControl>
        <input v-else type="text" class="form-control datetimes" v-model="data.noteUpdate" />
      </div>
      <div class="form-group">
        <label>Mô tả</label>
        <input placeholder="Mô tả" v-model="data.noteDes" />
      </div>
    </div>
    <hr />
    <form class="">
      <div class="form-group img-list">
        <ul class="m-0">
          <UploadMultiple
            @syncFile="syncFile"
            :lsData="fileImage"
            :maxFile="100"
            title="Ảnh giải trình"
            titleTag="h1"
            titleClass="form-inner-heading"
            uniqueKey="images"
          />
        </ul>
      </div>
      <h1 v-if="data.saleOfflineSignedImage" class="form-inner-heading">Ảnh checkin</h1>
      <div class="form-group img-list">
        <ul class="m-0">
          <li v-for="(image, index) in data.saleOfflineSignedImage" :key="index">
            <a href="#popup-slider" data-toggle="modal">
              <img :src="image" alt="" />
            </a>
          </li>
        </ul>
      </div>
    </form>
    <template #modal-footer="{ cancel }">
      <b-button size="sm" variant="light" @click="cancel()"> Hủy bỏ </b-button>
      <b-button size="sm" variant="primary" @click="updateWork"> Xác nhận </b-button>
    </template>
  </b-modal>
</template>

<script>
  import Config from '@/thirdParty/config'
  import UploadMultiple from '@/components/UploadMultiple.vue'
  import { CommonService } from '@/services/common.service'
  import moment from 'moment'
  import InputRange from '@/components/InputRange.vue'

  export default {
    components: {
      UploadMultiple,
      InputRange,
    },
    props: {
      dataUpdate: {
        type: Object,
        default: Object,
      },
      purposesSelected: {
        type: String,
        default: '',
      },
      fileImage: {
        type: Array,
        default: Array,
      },
      dateRangeProcessing: {
        type: Object,
        default: function () {
          return {}
        },
      },
    },
    data() {
      return {
        data: {},
        showModalUpdate: false,
        selectedStt: '',
        dataStatus: Config.statusCalendarAfs,
        optionsPurpose: Config.jobPurposes,
        selectedResult: null,
        dataResult: Config.resultCalendarAfs,
        localeData: Config.localeData,
        noteUpdateArr: [],
        noteUpdateType: null,
        noteUpdate: null,
        noteDes: null,
        dataDetail: {},
        fileUploads: [],
      }
    },
    watch: {
      dataUpdate(val) {
        this.data = val
      },
    },
    methods: {
      syncFile(files) {
        this.fileUploads = files
      },
      async updateWork() {
        const note = ['MC_INACTIVE', 'MC_DECREASE_TPV'].includes(this.data.noteUpdateType)
          ? this.data.noteUpdateArr.join(', ')
          : this.data.noteUpdate
        const files = await Promise.all(this.fileUploads.map(s => this.sendFile(s)))
        const update = {
          id: this.data.id,
          note: note,
          description: this.data.noteDes,
          purposes: [this.purposesSelected],
          result: this.data.selectedResult,
          images: files.map(s => s.urlFile),
          status: this.data.selectedStt,
          saleOfflineSignedImage: this.saleOfflineSignedImage,
          startProcessing: moment(this.dateRangeProcessing.startDate).valueOf(),
          endProcessing: moment(this.dateRangeProcessing.endDate).valueOf(),
        }
        if (note) {
          this.$emit('updateCalendar', update)
        } else this.showFailMx('Lý do k được để trống')
      },
      async sendFile(item) {
        if (item.file && item.status !== 'uploaded') {
          const formData = new FormData()
          formData.append('files', item.file)
          formData.append('folderName', 'NextCrm')
          const data = await CommonService.uploadImg(formData)
          const urlFile = data.data[0]
          item.url = urlFile
          item.status = 'uploaded'
          return { urlFile, type: item.type }
        } else return { urlFile: item.url, type: item.type }
      },
      onHidden() {
        this.$emit('onHidden')
      },
    },
  }
</script>

<style scoped></style>
